'use client'

import React, { ComponentType, useEffect, useState } from 'react'
import Button from '@/components/ui-other/basic/Button'
import { Team } from 'types'
import { Spinner } from '@/components/ui-other/basic/Spinner'
import { Trash2 } from 'react-feather'
import FavoriteIcon from 'public/img/ci-icons/favoriten.svg'

type MyTeamButtonProps = {
  team: Team
}

// export const MyTeamButton: ComponentType<MyTeamButtonProps> = ({
//   team
// }): ReactElement => {
//   return (
//     <ErrorBoundary fallback={<span>x</span>}>
//       <ActualMyTeamButton team={team} />
//     </ErrorBoundary>
//   )
// }

import { addMyTeam, canAddMyTeam } from '../../api/myTeam'
import { useSession } from 'lib/session-client'
// import { useRouter } from 'next/router'
import { myProfilePath, loginPath, teamPath } from 'shared/urlHelpers'
import { useRouter } from 'next/navigation'

export const MyTeamButton: ComponentType<MyTeamButtonProps> = ({ team }) => {
  const [submitting, setSubmitting] = useState(false)
  const [canAdd, setCanAdd] = useState(true)
  const { session } = useSession()
  const router = useRouter()

  useEffect(() => {
    if (session) {
      canAddMyTeam(team.id, session.accessToken).then((res) => {
        setCanAdd(res)
      })
    }
  }, [session])

  const handleOnClick = () => {
    if (session && canAdd) {
      setSubmitting(true)
      addMyTeam(team.id, session.accessToken).then((d) => {
        setSubmitting(false)
        setCanAdd(false)
      })
    } else if (session && !canAdd) {
      router.push(myProfilePath())
    } else {
      router.push(loginPath({ backTo: teamPath(team) }))
    }
  }

  return (
    <Button
      iconOnly
      small
      onClick={handleOnClick}
      color={canAdd ? 'primary' : 'gray'}
      tooltip={
        canAdd ? 'Zu „Meine Teams“ hinzufügen' : 'Von „Meine Teams“ entfernen'
      }
    >
      {submitting && (
        <>
          <Spinner loading={true} aria-hidden="true" />
          <span className="sr-only">Aktion wird verarbeitet</span>
        </>
      )}
      {!submitting && canAdd && (
        <>
          <FavoriteIcon aria-hidden="true" />
          <span className="sr-only">Zu „Meine Teams“ hinzufügen</span>
        </>
      )}
      {!submitting && !canAdd && (
        <>
          <Trash2 aria-hidden="true" />
          <span className="sr-only">Aus „Meine Teams“ entfernen</span>
        </>
      )}
    </Button>
  )
  
}
